import { joinURL } from 'ufo'
import { mobilePhoneSchema } from '~/server/schemas'

export default () => {
  const baseUrl = useRuntimeConfig().public.heatProtection.phoneCallBaseUrl
  const callData = ref<{ phone: string, name: string } | null>(null)

  const getUrl = (phone: string) => {
    const result = mobilePhoneSchema.safeParse(phone)
    if (!result.success || !result.data) {
      return null
    }
    return joinURL(baseUrl, `?dial=${result.data}`)
  }

  const isValid = (phone?: string | null) => {
    if (!phone) {
      return false
    }
    return mobilePhoneSchema.safeParse(phone).success
  }

  const performCall = () => {
    if (!callData.value) {
      return
    }
    const url = getUrl(callData.value.phone)
    if (url) {
      window.open(url, '_blank')
    }
    callData.value = null
  }

  const renderPhoneLink = (phoneNumber?: string | null, clickable: boolean = false) => {
    if (!phoneNumber) {
      return null
    }

    if (!clickable) {
      return h('span', phoneNumber)
    }

    const result = mobilePhoneSchema.safeParse(phoneNumber)
    if (!result.success || !result.data) {
      return h('span', phoneNumber)
    }

    const url = joinURL(baseUrl, `?dial=${result.data}`)

    return useRouterLink(phoneNumber, url, {
      external: true,
      class: 'text-blue-600 hover:text-blue-800 underline',
    })()
  }

  return {
    callData,
    performCall,
    renderPhoneLink,
    isValid,
  }
}
